import { documentsContext } from '../context/DocumentContext'
import { useContext } from 'react'

export const useDocumentsContext = () => {
  const context = useContext(documentsContext)

  if (!context) {
    throw Error('useDocumentsContext must be used inside an DocumentsContextProvider')
  }

  return context
}